exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".page h3[data-v-26a33e15]{margin:0;margin-bottom:20px;border-bottom:1px solid #333}.page .body[data-v-26a33e15]{padding-top:60px}.page .body ul[data-v-26a33e15]{list-style-type:none;padding:0;margin:0}.page .body ul li[data-v-26a33e15]{display:grid;grid-template-columns:40px 1fr;align-items:center;font-size:14px;font-weight:500;border-bottom:1px solid #ccc;padding:10px 0}.page .body ul li p[data-v-26a33e15]{margin:0;margin-top:4px;font-weight:600}.page .body ul li small[data-v-26a33e15]{color:#777}.page .body ul li table tr td[data-v-26a33e15]{font-size:14px}.page .body ul li table tr td[data-v-26a33e15]:first-child,.page .body ul li table tr td[data-v-26a33e15]:nth-child(2){padding-right:5px}.page .body ul li[data-v-26a33e15]:active{background:#eee}.page .body ul li.active[data-v-26a33e15]{background:#e7f7e9}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-26a33e15","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/pages/Peserta.vue
// module id = 226
// module chunks = 0